module.exports = __webpack_public_path__ + "img/plataformas-api.0e41f727.svg";